// extracted by mini-css-extract-plugin
export var li = "_uz-2";
export var ol = "_uz-1";
export var ul = "_uz-0";